import { GET_AGENT_SESSIONS } from '@takeshape/actions';
import { getPermission, type PermissionsSlice } from 'app/permissions/selectors';
import { getResourceString } from 'app/permissions/util';
import { useSelector } from 'react-redux';
import type { RouterSlice } from '../../../app-state';
import { getCurrentBranchPath } from '../../../branches/selectors';
import { getCurrentProjectId } from '../../../project/selectors';

export const useProjectToolbar = () => {
  return {
    projectId: useSelector(getCurrentProjectId),
    branchPath: useSelector(getCurrentBranchPath),
    route: useSelector((state: RouterSlice) => state.router.route),
    canUpdateProject: useSelector((state) =>
      getPermission(state as PermissionsSlice, {
        action: 'project:update',
        resource: getResourceString('project')
      })
    ),
    canViewAgentSessions: useSelector((state) =>
      getPermission(state as PermissionsSlice, {
        action: GET_AGENT_SESSIONS,
        resource: getResourceString('agents')
      })
    )
  };
};

export type ProjectToolbarHookProps = ReturnType<typeof useProjectToolbar>;
